<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">
        Сотрудники
      </h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(tab, i) in tabs" :key="i" :name="tab.key" :label="tab.name">
          <component :is="tab.component" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import UsersList from "@/components/Users/tabs/UsersList";
import UsersLogs from "@/components/Users/tabs/UsersLogs";

export default {
  name: "Users",
  data() {
    return {
      activeTab: "list",
      tabs: [
        {
          name: "Список",
          key: "list",
          component: UsersList,
        },
        {
          name: "Логи",
          key: "logs",
          component: UsersLogs,
        },
      ],
    };
  },
};
</script>
